import { render, staticRenderFns } from "./card-edit-path-bnd.vue?vue&type=template&id=190f871a&scoped=true&"
import script from "./card-edit-path-bnd.vue?vue&type=script&lang=js&"
export * from "./card-edit-path-bnd.vue?vue&type=script&lang=js&"
import style0 from "./card-edit-path-bnd.vue?vue&type=style&index=0&id=190f871a&prod&lang=scss&scoped=true&"
import style1 from "./card-edit-path-bnd.vue?vue&type=style&index=1&id=190f871a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190f871a",
  null
  
)

export default component.exports